import { createSelector } from 'reselect'

import { getRequestStatus } from '@cinch/oxd-utils/request-status/src'

const getUpdateStatus = (state: any) => state.lifestyle && state.lifestyle.status

export default createSelector(getUpdateStatus, (update) => getRequestStatus(update))
